import { customLoadStripe } from "../../atoms/Stripe";
import React, { useContext, useEffect, useState } from "react";
import {
    STRIPE_TOKEN,
    STRIPE_TOKEN1,
    STRIPE_TOKEN2,
} from "../../../utility/config";
import Button from "../../atoms/Button/Button";
import ToggleButton from "../../atoms/CustomToggle/ToggleButtonModified";
import SVGIcon from "../../atoms/SVGIcon";
import useHelperFunctions from "../../helperFunctions";
import styles from "./styles.module.css";

import { CREATE_PAYMENT } from "../../api.json";
import Logout from "../../../components/authentication/logout";
import { LightTooltip } from "../../atoms/Tooltip/tooltip";
import { RiLogoutCircleLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import { OnBoardingContext } from "../../Context/OnBoardingContext/OnBoardingContextProvider";
import WebsiteHtml from "./WebsiteHtml";
import Modal from "../../atoms/Modal/Modal";
import PlanTypeToggleButton from "../../atoms/CustomToggle/PlanTypeToggleButton";
import usePriceDiscounts, {
    getMonths,
    getYearSave,
    parsePrice,
} from "./usePriceDiscounts";
import { PLANS_CATEGORIES, PLANS_TYPE } from "../../../constants";
import useMixpanelHook from "../../../utility/useMixpanelHook";
import useUserAccessHook from "../../../components/account/useUserAccessHook";
import { planCatInfo } from "../../../components/subsCards/lists";
import DealTop from "../../../components/subsCards/DealTop";
import DealTopBF, {
    calculateResultantDiscount,
} from "../../../components/subsCards/DealTopBF";
import PostPaymentModalBF from "../../organisms/PostPaymentModal/PostPaymentModalBF";
import { SubscriptionToggle } from "../../../components/subsCards";
import PostPaymentModal from "../../organisms/PostPaymentModal/PostPaymentModal";
const exitIntentSubCards = [
    { src: "eip_cm.svg", id: 1, name: "Cruise Mode" },
    { src: "eip_aw.svg", id: 2, name: "Article Writer" },
    { src: "eip_research.svg", id: 3, name: "SEO Research" },
    { src: "eip_co.svg", id: 4, name: "Content Optimizer" },
    { src: "eip_integration.svg", id: 5, name: "Integrations" },
    { src: "eip_kp.svg", id: 6, name: "Keyword Planner" },
];

function CCUser() {
    const { postData } = useHelperFunctions();
    const [loading, setLoading] = useState(false);
    const otherInfo = useSelector((state) => state.otherInfo);
    const email = useSelector((state) => state.auth.email);
    const { ccPlan } = useContext(OnBoardingContext);
    const { deals } = useSelector((state) => state.appConfig);
    const [isDeal, setIsDeal] = useState(false);

    const {
        plans,
        planTypesWithDiscount,
        plansType,
        setPlansType,
        getDiscount,
    } = usePriceDiscounts();
    const { top, bottom } = WebsiteHtml({
        subs: false,
        plansType,
        cards: plans,
        isDeal,
        setPlansType,
        getDiscount,
        // dealsLimit: deals ? JSON.parse(deals)?.dealLimitsMultiplier : 1,
        dealsLimit: isDeal ? 2 : 1,
    });

    //plan type -> monthly yearly
    //plan cat -> indvi growth pro
    useEffect(() => {
        if (ccPlan) {
            purchaseHandler(ccPlan);
        }
    }, []);

    const purchaseHandler = async (planId) => {
        setLoading(true);
        let stripeID =
            otherInfo?.subscriptionInfo?.stripe_region == 2
                ? STRIPE_TOKEN2
                : STRIPE_TOKEN1;
        const stripe = await customLoadStripe(stripeID);
        let baseURL = window.location.origin;
        let successURL = `${baseURL}/admin/transaction568894547/98797984111237/?session_id={CHECKOUT_SESSION_ID}&dashboard=true`;
        let cancelURL = `${baseURL}/admin/account/plans`;
        let criteria = {
            successURL,
            cancelURL,
            mode: "subscription",
            tid: localStorage.getItem("FPROM_ID"),
            type: 1,
            planID: planId,
        };

        const response = await postData({
            url: CREATE_PAYMENT,
            payload: criteria,
        });
        if (response.status == 200)
            stripe.redirectToCheckout({
                sessionId: response?.data?.paymentTransactionID,
            });
        else {
            setLoading(false);
        }
    };

    const sortCards = (card1, card2) => card1.plan_cost - card2.plan_cost;

    return (
        <div className={styles.ccPlansContainer}>
            <ExitIntentModal />
            <div className={styles.header} style={{ marginBottom: "10px" }}>
                <div className={styles.logo}>
                    <SVGIcon size={32} src="/New UI/SVG/Scalenut.svg"></SVGIcon>{" "}
                    Scalenut
                </div>
                <div>
                    <Logout
                        render={(logout) => (
                            <LightTooltip
                                placement="bottom"
                                title={
                                    <>
                                        <div>Logged In as:</div>
                                        <div>{email}</div>
                                    </>
                                }
                                arrow
                            >
                                <div>
                                    <Button
                                        width="100px"
                                        height={30}
                                        handler={() => logout()}
                                        iconReverse
                                        Icon={RiLogoutCircleLine}
                                        text="Logout"
                                        style={{
                                            fontSize: 14,
                                            backgroundColor: "rgba(0,0,0,0.05)",
                                            color: "var(--secondary-color)",
                                        }}
                                    />
                                </div>
                            </LightTooltip>
                        )}
                    />
                </div>
            </div>
            <DealTopBF isCC={true} deals={deals} />
            {/* <PostPaymentModal plansType={plansType} /> */}
            <div className={styles.body}>
                <header>
                    <h2>Select a plan to start your 7 days risk free trial.</h2>
                    <h3>
                        We<u>don't charge</u>until your trial expires. You can
                        cancel anytime.
                    </h3>
                </header>
                <div className={styles.toggleWrapper}>
                    <SubscriptionToggle
                        plansType={plansType}
                        setPlansType={setPlansType}
                        isDeal={isDeal}
                        getDiscount={getDiscount}
                    />
                </div>
                {/* <PlanTypeToggleButton
                    options={planTypesWithDiscount}
                    callback={(value) => {
                        setPlansType(value);
                    }}
                    defaultValue={PLANS_TYPE.YEARLY}
                ></PlanTypeToggleButton> */}

                {plans.length ? (
                    <section className={styles.cardsContainer}>
                        {plans
                            .sort(sortCards)
                            .filter(
                                (plan) =>
                                    plan.plan_type == plansType &&
                                    plan.plan_category !=
                                        PLANS_CATEGORIES.INTER_LINKING,
                            )
                            .map((plan, i) => (
                                <PlanCard
                                    fav={i == 1}
                                    purchaseHandler={purchaseHandler}
                                    plan={plan}
                                    loading={loading}
                                    getDiscount={getDiscount}
                                    plansType={plansType}
                                    isDeal={isDeal}
                                />
                            ))}
                    </section>
                ) : (
                    <></>
                )}

                <footer></footer>

                {top}
                <DealTop isCC={true} />

                {bottom}
            </div>
        </div>
    );
}

export default CCUser;

const PlanCard = ({
    plan,
    purchaseHandler,
    fav,
    loading,
    getDiscount,
    plansType,
    isDeal,
}) => {
    const [_loading, setLoading] = useState(false);

    useEffect(() => {
        if (!loading) setLoading(false);
    }, [loading]);
    const freeuser = true;

    return (
        <div className={`${styles.planCard} ${fav ? styles.favPlan : ""}`}>
            {fav && (
                <div
                    style={{ background: isDeal ? "#6cd1db" : "" }}
                    className={styles.popular}
                >
                    Most Popular
                </div>
            )}
            <h2>{plan.plan_name}</h2>
            <p style={{ minHeight: "40px" }}>
                {planCatInfo(plansType)[plan.plan_category]?.subTitle}
            </p>

            <div className={styles.cardPricingDiv}>
                <div className={styles.cardPriceOriginaldiv}>
                    {freeuser && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "20px",
                            }}
                        >
                            <span
                                style={{
                                    visibility: !getDiscount(plan.plan_type)
                                        ? "hidden"
                                        : "unset",
                                }}
                                className={styles.cardPriceOriginalDis}
                            >
                                {parsePrice(
                                    plan.plan_cost,
                                    plan.currency,
                                    plan.plan_type,
                                )}
                            </span>
                            <span
                                className={styles.offer}
                                style={{
                                    visibility: !getDiscount(plan.plan_type)
                                        ? "hidden"
                                        : "unset",
                                    background: isDeal
                                        ? "linear-gradient(101deg, #6cd1db -90%, #c5f4ff 114%)"
                                        : "",
                                }}
                            >
                                <strong style={{ fontWeight: 500 }}>
                                    {getDiscount(plan.plan_type)}% OFF
                                </strong>{" "}
                                Limited Time Offer
                            </span>
                        </div>
                    )}
                    <span className={styles.cardPriceOriginal}>
                        {parsePrice(
                            plan.plan_cost,
                            plan.currency,
                            plan.plan_type,
                            getDiscount(plan.plan_type),
                        )}
                    </span>
                    {"/mo"}
                    {freeuser && (
                        <div
                            className={styles.youSave}
                            style={{
                                visibility: !getDiscount(plan.plan_type)
                                    ? "hidden"
                                    : "unset",
                            }}
                        >
                            Billed annually{" "}
                            <strong>
                                (Save{" "}
                                {getYearSave(
                                    plan.plan_cost,
                                    plan.currency,
                                    plan.plan_type,
                                    getDiscount(plan.plan_type),
                                )}
                                /Year)
                            </strong>
                        </div>
                    )}
                </div>
            </div>

            <Button
                disabled={loading}
                style={{
                    background: isDeal ? "#6922e9" : "#0079e4",
                    fontSize: 14,
                }}
                handler={() => {
                    setLoading(true);
                    purchaseHandler(plan.plan_id);
                }}
                Icon={() => <SVGIcon src="/New UI/SVG/bsarrowright.svg" />}
                text="Start your 7 day Free Trial!"
                loading={_loading}
            ></Button>

            <ul className={styles.checksList}>
                <h4
                    style={{
                        visibility:
                            planCatInfo(plansType, isDeal)[plan.plan_category]
                                ?.includes == "none"
                                ? "hidden"
                                : "visible",
                    }}
                >
                    {
                        planCatInfo(plansType, isDeal)[plan.plan_category]
                            ?.includes
                    }
                </h4>
                {planCatInfo(plansType, isDeal)[
                    plan.plan_category
                ]?.checks?.map((text) => (
                    <li>
                        {text.isAddOn ? (
                            <div style={{ marginRight: "20px" }}>+</div>
                        ) : (
                            !text.noCheck && (
                                <div className={styles.check}>
                                    <SVGIcon
                                        size={13}
                                        src="/New UI/SVG/check.svg"
                                    ></SVGIcon>
                                </div>
                            )
                        )}
                        {text?.text ? text?.text : text}
                    </li>
                ))}
            </ul>
        </div>
    );
};

const PlanCardBF = ({
    plan,
    purchaseHandler,
    fav,
    loading,
    getDiscount,
    plansType,
}) => {
    const [_loading, setLoading] = useState(false);

    useEffect(() => {
        if (!loading) setLoading(false);
    }, [loading]);
    const freeuser = true;

    return (
        <div
            className={`${styles.planCard} ${styles.planCardBF}  ${
                fav ? styles.favPlan : ""
            }`}
        >
            {fav && <div className={styles.popular}>Most Popular</div>}
            <h2>{plan.plan_name}</h2>
            <p
                style={{ minHeight: "40px" }}
                className={styles.PlanCardBF_subtitle}
            >
                {planCatInfo(plansType)[plan.plan_category]?.subTitle}
            </p>

            <div className={styles.cardPricingDiv}>
                <div className={styles.cardPriceOriginaldiv}>
                    {freeuser && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "20px",
                                marginBottom: 10,
                            }}
                        >
                            <span
                                style={{
                                    visibility: !getDiscount(plan.plan_type)
                                        ? "hidden"
                                        : "unset",
                                }}
                                className={styles.cardPriceOriginalDis}
                            >
                                {parsePrice(
                                    plan.plan_cost,
                                    plan.currency,
                                    plan.plan_type,
                                )}
                            </span>
                            <span
                                className={styles.offer}
                                style={{
                                    visibility: !getDiscount(plan.plan_type)
                                        ? "hidden"
                                        : "unset",
                                }}
                            >
                                <strong style={{ fontWeight: 500 }}>
                                    {20}% OFF
                                </strong>{" "}
                                Regular Offer
                            </span>
                        </div>
                    )}
                    {freeuser && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "20px",
                            }}
                        >
                            <span
                                style={{
                                    visibility: !getDiscount(plan.plan_type)
                                        ? "hidden"
                                        : "unset",
                                }}
                                className={styles.cardPriceOriginalDis}
                            >
                                {parsePrice(
                                    plan.plan_cost,
                                    plan.currency,
                                    plan.plan_type,
                                    20,
                                )}
                            </span>
                            <span
                                className={styles.offer}
                                style={{
                                    visibility: !getDiscount(plan.plan_type)
                                        ? "hidden"
                                        : "unset",
                                }}
                            >
                                <strong style={{ fontWeight: 500 }}>
                                    {getDiscount(plan.plan_type)}% OFF
                                </strong>{" "}
                                BF Discount
                            </span>
                        </div>
                    )}
                    <span className={styles.cardPriceOriginal}>
                        {parsePrice(
                            plan.plan_cost,
                            plan.currency,
                            plan.plan_type,
                            getDiscount(plan.plan_type),
                        )}
                    </span>
                    {"/mo"}
                    {freeuser && (
                        <div
                            className={styles.youSave}
                            style={{
                                visibility: !getDiscount(plan.plan_type)
                                    ? "hidden"
                                    : "unset",
                            }}
                        >
                            Billed annually{" "}
                            <strong>
                                (Save{" "}
                                {getYearSave(
                                    plan.plan_cost,
                                    plan.currency,
                                    plan.plan_type,
                                    getDiscount(plan.plan_type),
                                )}
                                /Year)
                            </strong>
                        </div>
                    )}
                </div>
            </div>

            <Button
                disabled={loading}
                style={{
                    backgroundColor: "#f3c975",
                    fontSize: 14,
                    color: "#000",
                }}
                handler={() => {
                    setLoading(true);
                    purchaseHandler(plan.plan_id);
                }}
                Icon={() => <SVGIcon src="/New UI/SVG/bsarrowright.svg" />}
                text="Start your 7 day Free Trial!"
                loading={_loading}
            ></Button>

            <ul className={styles.checksList}>
                <h4
                    style={{
                        visibility:
                            planCatInfo(plansType)[plan.plan_category]
                                ?.includes == "none"
                                ? "hidden"
                                : "visible",
                    }}
                >
                    {planCatInfo(plansType)[plan.plan_category]?.includes}
                </h4>
                {planCatInfo(plansType)[plan.plan_category]?.checks?.map(
                    (text) => (
                        <li>
                            <div className={styles.checkBF}>
                                <SVGIcon
                                    size={13}
                                    src="/New UI/SVG/SingleTick.svg"
                                ></SVGIcon>
                            </div>
                            {text?.text ? text?.text : text}
                        </li>
                    ),
                )}
            </ul>
        </div>
    );
};

export const ExitIntentModal = ({ handler = () => {} }) => {
    const [open, setOpen] = useState(1);
    const name = useSelector((state) => state.auth.user_name);
    const { deals } = useSelector((state) => state.appConfig);
    const [_deals, setDeals] = useState({});
    useEffect(() => {
        if (deals) {
            setDeals(JSON.parse(deals));
        }
    }, [deals]);

    useEffect(() => {
        document.onmouseleave = () => {
            setOpen((ps) => (ps ? ps - 1 : ps));
        };

        setTimeout(() => {
            setOpen((ps) => (ps ? ps - 1 : ps));
        }, 30000);

        document.onbeforeunload = () => {
            return "are you sure?";
        };
        return () => {
            document.removeEventListener("mouseout", setOpen);
            document.onmouseleave = () => {};
        };
    }, []);

    return (
        <>
            {!open && (
                <Modal setModal={() => setOpen((ps) => ps - 1)}>
                    <div className={styles.intentPopup}>
                        <span
                            onClick={() => setOpen((ps) => ps - 1)}
                            className={styles.cross}
                        >
                            <SVGIcon
                                color="white"
                                src="/New UI/SVG/cross.svg"
                            />
                        </span>
                        <div className={styles.textContainer}>
                            <Button
                                style={{
                                    background: "#fada4c",
                                    color: "#010148",
                                    width: "fit-content",
                                    padding: "24px 18px",
                                    borderRadius: "11px",
                                    fontSize: "20px",
                                    position: "absolute",
                                    bottom: "17px",
                                }}
                                text={"Try Link Manager Today"}
                                handler={() => {
                                    handler(true);
                                    setOpen((ps) => ps - 1);
                                }}
                            />
                        </div>
                        {/* <div className={styles.topLogo}>
                            <SVGIcon src={"/New UI/SVG/ScalenutWhite.svg"} />{" "}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                color: "#003954",
                                fontSize: "42px",
                                fontWeight: "600",
                                marginBottom: "30px",
                            }}
                        >
                            Hop into savings!
                        </div>
                        <div
                            style={{
                                fontWeight: "600",
                                fontSize: "36px",
                                marginTop: "40px",
                                marginBottom: "80px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "20px",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "36px",
                                            marginBottom: "-10px",
                                        }}
                                    >
                                        55
                                        <span style={{ fontSize: "16px" }}>
                                            %
                                        </span>{" "}
                                    </div>
                                    Off{" "}
                                </div>
                                <div style={{ marginInline: "10px" }}>+</div>
                                <div
                                    style={{
                                        fontSize: "16px",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "36px",
                                            marginBottom: "-10px",
                                        }}
                                    >
                                        2X
                                    </div>
                                    Limits{" "}
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    fontSize: "24px",
                                }}
                            >
                                &
                            </div>
                            <div
                                style={{
                                    textAlign: "center",
                                    marginTop: "10px",
                                    fontSize: "24px",
                                }}
                            >
                                Guaranteed
                                <br /> Rewards
                            </div>
                        </div>
                        <div
                            style={{
                                color: "#003954",
                                fontSize: "20px",
                                fontWeight: "600",
                                textAlign: "center",
                                marginBottom: "30px",
                            }}
                        >
                            on all Annual Plans
                            <br />
                            as our Easter treat to you!
                        </div> */}
                    </div>
                </Modal>
            )}
        </>
    );
};
